module.exports = __webpack_public_path__ + "static/assets/9789efbc62a14981c9809b6cc3965769.png";